<table class="table table-striped table-fixed ctable">
  <thead>
    <tr style="width: 98%;">
      <th scope="col">Item Id</th>
      <th scope="all">Picture</th>
      <th scope="col">Description</th>
      <th scope="col">Sender & #Tracking</th>
      <th scope="col">Weight</th>
      <th scope="col">Value</th>
      <th scope="col">Ar. Date</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of itemList">
      <td data-title="Item Id">
        <span class="badge bg-{{ item.statusColor }}" title="{{ item.statusText }}">{{ item.id }} </span>
      </td>
      <td>
          <img [src]="item?.pictures[0]" class="img-fluid" style="max-width: 50%;" (click)="openImageModal(item)"
          onError="this.src='assets/images/dummy.jpg';" alt="">
      </td>
      <td data-title="Description"> {{ item.quantity }} x {{ item.itemDescription }}</td>
      <td data-title="Sender & #Tracking">
        {{ item.sender }} - {{ item.trackingNumber }}
      </td>
      <td data-title="Weight">{{ item.selectedWeight }} Lbs</td>
      <td data-title="Value">{{ item.itemValue | currency }}</td>
      <td data-title="Ar. Date">
        {{ item.arrivedDate | date:'mediumDate'}}
      </td>
    </tr>
  </tbody>
</table>